import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import DataTable from '../DataTable';
import { toJS } from 'mobx';
import Spinner from '../Spinner';

@inject('metaDataTemplateStore')
@observer
class MetaDataTemplateList extends Component {
  static propTypes = {
    params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
    children: PropTypes.node,
  }

  static contextTypes = {
    notify: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.handleDelete = this.handleDelete.bind(this);
  }

  componentWillMount() {
    const { metaDataTemplateStore } = this.props;
    metaDataTemplateStore.fetchItems();
  }

  handleDelete(idOrIds) {
    const { notify } = this.context;
    this.props.metaDataTemplateStore.removeItems(idOrIds)
      .then(() => {
        notify.success({ message: 'Deleted' });
      })
      .catch((err) => {
        console.trace(err);
        notify.error(err);
      });
  }

  slug = 'configurations/meta-data/template';
  columns = [
    { key: 'id', label: 'ID' },
    { key: 'name', label: 'Name' },
    { key: 'description', label: 'Description' },
  ];

  render() {
    const { metaDataTemplateStore, children } = this.props;

    if (metaDataTemplateStore.isLoading) return <Spinner />

    return (
      <div>
        <DataTable
          data={toJS(metaDataTemplateStore.items)}
          slug={this.slug}
          columns={this.columns}
          onDelete={this.handleDelete}
          allowAdd
          allowEdit
          allowDelete
          resource='meta-data-template'
        />
        {children}
      </div>
    );
  }
}

export default MetaDataTemplateList;



// WEBPACK FOOTER //
// ./src/components/MetaDataTemplate/MetaDataTemplateList.js